/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  MessageSchedulePutRequest,
  MessageSendPostRequest,
  ReceivedMessagesResponse,
  SchedulesResponse,
  SentMessagesResponse,
} from '../models';
import {
    MessageSchedulePutRequestFromJSON,
    MessageSchedulePutRequestToJSON,
    MessageSendPostRequestFromJSON,
    MessageSendPostRequestToJSON,
    ReceivedMessagesResponseFromJSON,
    ReceivedMessagesResponseToJSON,
    SchedulesResponseFromJSON,
    SchedulesResponseToJSON,
    SentMessagesResponseFromJSON,
    SentMessagesResponseToJSON,
} from '../models';

export interface MessageReceiveListGetRequest {
    dc: string;
    aisweb: MessageReceiveListGetAiswebEnum;
    begin?: Date;
    end?: Date;
}

export interface MessageScheduleGetRequest {
    dc: string;
}

export interface MessageSchedulePostRequest {
    messageSchedulePutRequest: MessageSchedulePutRequest;
}

export interface MessageSchedulePutOperationRequest {
    messageSchedulePutRequest: MessageSchedulePutRequest;
}

export interface MessageScheduleUidDeleteRequest {
    uid: string;
    dc: string;
}

export interface MessageSendListGetRequest {
    dc: string;
    aisweb: MessageSendListGetAiswebEnum;
    begin?: Date;
    end?: Date;
}

export interface MessageSendPostOperationRequest {
    messageSendPostRequest: MessageSendPostRequest;
}

/**
 * 
 */
export class MessageApi extends runtime.BaseAPI {

    /**
     * Get list of received messages
     */
    async messageReceiveListGetRaw(requestParameters: MessageReceiveListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReceivedMessagesResponse>> {
        if (requestParameters.dc === null || requestParameters.dc === undefined) {
            throw new runtime.RequiredError('dc','Required parameter requestParameters.dc was null or undefined when calling messageReceiveListGet.');
        }

        if (requestParameters.aisweb === null || requestParameters.aisweb === undefined) {
            throw new runtime.RequiredError('aisweb','Required parameter requestParameters.aisweb was null or undefined when calling messageReceiveListGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.dc !== undefined) {
            queryParameters['_dc'] = requestParameters.dc;
        }

        if (requestParameters.aisweb !== undefined) {
            queryParameters['aisweb'] = requestParameters.aisweb;
        }

        if (requestParameters.begin !== undefined) {
            queryParameters['begin'] = (requestParameters.begin as any).toISOString();
        }

        if (requestParameters.end !== undefined) {
            queryParameters['end'] = (requestParameters.end as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/message/receive/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReceivedMessagesResponseFromJSON(jsonValue));
    }

    /**
     * Get list of received messages
     */
    async messageReceiveListGet(requestParameters: MessageReceiveListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReceivedMessagesResponse> {
        const response = await this.messageReceiveListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get schedule
     */
    async messageScheduleGetRaw(requestParameters: MessageScheduleGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SchedulesResponse>> {
        if (requestParameters.dc === null || requestParameters.dc === undefined) {
            throw new runtime.RequiredError('dc','Required parameter requestParameters.dc was null or undefined when calling messageScheduleGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.dc !== undefined) {
            queryParameters['_dc'] = requestParameters.dc;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/message/schedule`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SchedulesResponseFromJSON(jsonValue));
    }

    /**
     * Get schedule
     */
    async messageScheduleGet(requestParameters: MessageScheduleGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SchedulesResponse> {
        const response = await this.messageScheduleGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new schedule
     */
    async messageSchedulePostRaw(requestParameters: MessageSchedulePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.messageSchedulePutRequest === null || requestParameters.messageSchedulePutRequest === undefined) {
            throw new runtime.RequiredError('messageSchedulePutRequest','Required parameter requestParameters.messageSchedulePutRequest was null or undefined when calling messageSchedulePost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/message/schedule`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MessageSchedulePutRequestToJSON(requestParameters.messageSchedulePutRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create a new schedule
     */
    async messageSchedulePost(requestParameters: MessageSchedulePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.messageSchedulePostRaw(requestParameters, initOverrides);
    }

    /**
     * Update a schedule
     */
    async messageSchedulePutRaw(requestParameters: MessageSchedulePutOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.messageSchedulePutRequest === null || requestParameters.messageSchedulePutRequest === undefined) {
            throw new runtime.RequiredError('messageSchedulePutRequest','Required parameter requestParameters.messageSchedulePutRequest was null or undefined when calling messageSchedulePut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/message/schedule`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MessageSchedulePutRequestToJSON(requestParameters.messageSchedulePutRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a schedule
     */
    async messageSchedulePut(requestParameters: MessageSchedulePutOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.messageSchedulePutRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a schedule
     */
    async messageScheduleUidDeleteRaw(requestParameters: MessageScheduleUidDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.uid === null || requestParameters.uid === undefined) {
            throw new runtime.RequiredError('uid','Required parameter requestParameters.uid was null or undefined when calling messageScheduleUidDelete.');
        }

        if (requestParameters.dc === null || requestParameters.dc === undefined) {
            throw new runtime.RequiredError('dc','Required parameter requestParameters.dc was null or undefined when calling messageScheduleUidDelete.');
        }

        const queryParameters: any = {};

        if (requestParameters.dc !== undefined) {
            queryParameters['_dc'] = requestParameters.dc;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/message/schedule/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(requestParameters.uid))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a schedule
     */
    async messageScheduleUidDelete(requestParameters: MessageScheduleUidDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.messageScheduleUidDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Get list of sent messages
     */
    async messageSendListGetRaw(requestParameters: MessageSendListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SentMessagesResponse>> {
        if (requestParameters.dc === null || requestParameters.dc === undefined) {
            throw new runtime.RequiredError('dc','Required parameter requestParameters.dc was null or undefined when calling messageSendListGet.');
        }

        if (requestParameters.aisweb === null || requestParameters.aisweb === undefined) {
            throw new runtime.RequiredError('aisweb','Required parameter requestParameters.aisweb was null or undefined when calling messageSendListGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.dc !== undefined) {
            queryParameters['_dc'] = requestParameters.dc;
        }

        if (requestParameters.aisweb !== undefined) {
            queryParameters['aisweb'] = requestParameters.aisweb;
        }

        if (requestParameters.begin !== undefined) {
            queryParameters['begin'] = (requestParameters.begin as any).toISOString();
        }

        if (requestParameters.end !== undefined) {
            queryParameters['end'] = (requestParameters.end as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/message/send/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SentMessagesResponseFromJSON(jsonValue));
    }

    /**
     * Get list of sent messages
     */
    async messageSendListGet(requestParameters: MessageSendListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SentMessagesResponse> {
        const response = await this.messageSendListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send a new message
     */
    async messageSendPostRaw(requestParameters: MessageSendPostOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.messageSendPostRequest === null || requestParameters.messageSendPostRequest === undefined) {
            throw new runtime.RequiredError('messageSendPostRequest','Required parameter requestParameters.messageSendPostRequest was null or undefined when calling messageSendPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/message/send`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MessageSendPostRequestToJSON(requestParameters.messageSendPostRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Send a new message
     */
    async messageSendPost(requestParameters: MessageSendPostOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.messageSendPostRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const MessageReceiveListGetAiswebEnum = {
    True: 'true'
} as const;
export type MessageReceiveListGetAiswebEnum = typeof MessageReceiveListGetAiswebEnum[keyof typeof MessageReceiveListGetAiswebEnum];
/**
 * @export
 */
export const MessageSendListGetAiswebEnum = {
    True: 'true'
} as const;
export type MessageSendListGetAiswebEnum = typeof MessageSendListGetAiswebEnum[keyof typeof MessageSendListGetAiswebEnum];
